import { jsx } from "react/jsx-runtime";
import { B as Box, c as ce } from "./Grid-CcQKdsgp.js";
const typographyStyle = ce({
  variants: {
    sizeFont: {
      large: "[font-size:var(--fontSize-mobile-large-body)] md:[font-size:var(--fontSize-desktop-large-body)]",
      medium: "[font-size:var(--fontSize-mobile-medium-body)] md:[font-size:var(--fontSize-desktop-medium-body)]",
      small: "[font-size:var(--fontSize-mobile-small-body)] md:[font-size:var(--fontSize-desktop-small-body)]",
      xsmall: "[font-size:var(--fontSize-mobile-xsmall-body)] md:[font-size:var(--fontSize-desktop-xsmall-body)]"
    },
    sizeLineHeight: {
      large: "[line-height:var(--lineHeight-mobile-large-body)] md:[line-height:var(--lineHeight-desktop-large-body)]",
      medium: "[line-height:var(--lineHeight-mobile-medium-body)] md:[line-height:var(--lineHeight-desktop-medium-body)]",
      small: "[line-height:var(--lineHeight-mobile-small-body)] md:[line-height:var(--lineHeight-desktop-small-body)]",
      xsmall: "[line-height:var(--lineHeight-mobile-xsmall-body)] md:[line-height:var(--lineHeight-desktop-xsmall-body)]"
    }
  }
});
const Typography = ({
  size = "medium",
  weight,
  className,
  md,
  d,
  children,
  as = "p",
  ...props
}) => {
  var _a, _b, _c, _d, _e;
  const fontWeight = weight ? `mobile.${weight}` : void 0;
  const mdFontWeight = (md == null ? void 0 : md.weight) !== weight && (md == null ? void 0 : md.weight) ? `desktop.${md == null ? void 0 : md.weight}` : void 0;
  const dFontWeight = (d == null ? void 0 : d.weight) !== (md == null ? void 0 : md.weight) && (d == null ? void 0 : d.weight) !== weight && (d == null ? void 0 : d.weight) ? `desktop.${d.weight}` : void 0;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...props,
      d: {
        ...d,
        fontWeight: (_b = (_a = d == null ? void 0 : d.fontWeight) != null ? _a : md == null ? void 0 : md.fontWeight) != null ? _b : dFontWeight
      },
      md: {
        ...md,
        fontWeight: (_d = (_c = md == null ? void 0 : md.fontWeight) != null ? _c : props.fontWeight) != null ? _d : mdFontWeight
      },
      fontWeight: (_e = props.fontWeight) != null ? _e : fontWeight,
      className: `${typographyStyle({
        sizeFont: props.fontSize ? void 0 : size,
        sizeLineHeight: props.lineHeight ? void 0 : size
      })} ${className != null ? className : ""}`,
      style: props.style,
      as,
      children
    }
  );
};
export {
  Typography as T
};
